import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: { name: "Admin" },
    role: "admin",
    isAuth: true,
  },
  reducers: {
    logout: (state) => {
      state.isAuth = false;
    },
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
